export enum TARIFAS {
  TD20 = '2.0TD',
  TD30 = '3.0TD',
}
